/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { localizeType } from '../../../../commonType';
import { dateArrayIncludes } from '../../../../util/date';
import withLocalization from '../../../hoc/withLocalization';
import './Day.scss';

interface IProps {
  day: Date;
  selectedDates: Date[];
  onClick(date: Date, dateIndex?: number): void;
  isOtherMoth?: boolean;
  premiumDates?: string[];
  packagePrice?: string;
  surCharge?: string;
  totalPrice?: string;
  selectable?: boolean;
  dateIndex?: number;
  localize: localizeType;
  isPremiumDate: boolean;
  hasExtraNights: boolean;
  extraNightCharge?: string;
}
interface IState {}

class Day extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  getClassList(): string {
    let classList = 'day';

    if (!this.props.isOtherMoth && dateArrayIncludes(this.props.day, this.props.selectedDates)) {
      classList += ' selected';
      if (this.props.selectedDates[0].valueOf() === this.props.day.valueOf()) {
        classList += ' selected-first';
      }
      if (this.props.selectedDates[this.props.selectedDates.length - 1].valueOf() <= this.props.day.valueOf()) {
        classList += ' selected-last';
      }
    }
    if (this.props.isPremiumDate) {
      classList += ' char';
    }
    if (this.props.isOtherMoth === true) {
      classList += ' othermonth';
    }
    if (this.props.selectable === false) {
      classList += ' othermonth';
    }
    return classList;
  }
  onClick() {
    if (this.props.selectable) {
      this.props.onClick(this.props.day, this.props.dateIndex);
    }
  }

  renderTooltip() {
    const { localize, packagePrice, surCharge, totalPrice, hasExtraNights, extraNightCharge } = this.props;

    return this.props.selectable ? (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        transition={false}
        overlay={
          <Tooltip id="priceTooltip">
            <span className="dayTooltipContent">
              {localize('preview-sales-engine.static-content.copy.calendar-page.tt-package-price', packagePrice)}
            </span>
            <br />
            <span className="dayTooltipContent">
              {localize('preview-sales-engine.static-content.copy.calendar-page.tt-surcharge-price', surCharge)}
            </span>
            <br />
            {hasExtraNights ? (
              <>
                {' '}
                <span className="dayTooltipContent">
                  {localize('preview-sales-engine.static-content.copy.Labels.labels#additional-night-charge')}{' '}
                  {extraNightCharge}
                </span>
                <br />
              </>
            ) : (
              <></>
            )}
            <span className="dayTooltipContent">
              {localize('preview-sales-engine.static-content.copy.calendar-page.tt-total-price', totalPrice)}
            </span>
          </Tooltip>
        }
      >
        {({ ref, ...triggerHandler }) => (
          <div className={this.getClassList()} onClick={this.onClick} ref={ref} {...triggerHandler}>
            <button className="date">{this.props.day.getDate()}</button>
          </div>
        )}
      </OverlayTrigger>
    ) : (
      <div className={this.getClassList()}>
        <button className="date" onClick={this.onClick} disabled>
          {this.props.day.getDate()}
        </button>
      </div>
    );
  }
  render() {
    const comp = this.renderTooltip();
    return (
      // eslint-disable-next-line react/jsx-no-comment-textnodes
      { ...comp }
    );
  }
}

export default withLocalization(Day);
